import React, { useState } from "react";
import { AuthService } from "../../services/authService";

const SecuritySection = () => {
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
    // Limpa erros quando o usuário digita
    if (errors[id]) {
      setErrors((prev) => ({ ...prev, [id]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.currentPassword) {
      newErrors.currentPassword = "Senha atual é obrigatória";
    }

    if (!formData.newPassword) {
      newErrors.newPassword = "Nova senha é obrigatória";
    } else if (formData.newPassword.length < 6) {
      newErrors.newPassword = "Senha deve ter pelo menos 6 caracteres";
    }

    if (formData.newPassword !== formData.confirmPassword) {
      newErrors.confirmPassword = "As senhas não coincidem";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitting(true);

      try {
        const response = await AuthService.changePassword(
          formData.currentPassword,
          formData.newPassword
        );

        setTimeout(() => {
          // console.log("Dados enviados:", formData);
          setSuccessMessage("Senha atualizada com sucesso!");
          setIsSubmitting(false);
          setFormData({
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
          });
        }, 1500);
      } catch (error) {
        console.error("Erro ao mudar a senha:", error);
        setIsSubmitting(false);
        setSuccessMessage("Erro ao atualizar a senha. Tente novamente.");
      }
    }
  };

  return (
    <div className="space-y-4 pt-4 m-[2%]">
      <div className="rounded-lg border bg-white shadow-sm">
        <div className="p-6 border-b">
          <h2 className="text-xl font-semibold">Segurança</h2>
          <p className="text-sm text-gray-500">
            Gerencie sua senha e configurações de segurança
          </p>
        </div>

        <div className="p-6 space-y-6">
          {successMessage && (
            <div className="p-4 bg-green-100 text-green-800 rounded-md">
              {successMessage}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            {/* Campo Senha Atual */}
            <div className="space-y-2">
              <label
                htmlFor="currentPassword"
                className="block text-sm font-medium text-gray-700"
              >
                Senha Atual
              </label>
              <input
                id="currentPassword"
                type="password"
                value={formData.currentPassword}
                onChange={handleChange}
                className={`block w-full rounded-md ${
                  errors.currentPassword ? "border-red-500" : "border-gray-300"
                } shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm p-2 border`}
              />
              {errors.currentPassword && (
                <p className="text-sm text-red-600">{errors.currentPassword}</p>
              )}
            </div>

            {/* Campo Nova Senha */}
            <div className="space-y-2">
              <label
                htmlFor="newPassword"
                className="block text-sm font-medium text-gray-700"
              >
                Nova Senha
              </label>
              <input
                id="newPassword"
                type="password"
                value={formData.newPassword}
                onChange={handleChange}
                className={`block w-full rounded-md ${
                  errors.newPassword ? "border-red-500" : "border-gray-300"
                } shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm p-2 border`}
              />
              {errors.newPassword && (
                <p className="text-sm text-red-600">{errors.newPassword}</p>
              )}
            </div>

            {/* Campo Confirmar Senha */}
            <div className="space-y-2">
              <label
                htmlFor="confirmPassword"
                className="block text-sm font-medium text-gray-700"
              >
                Confirmar Nova Senha
              </label>
              <input
                id="confirmPassword"
                type="password"
                value={formData.confirmPassword}
                onChange={handleChange}
                className={`block w-full rounded-md ${
                  errors.confirmPassword ? "border-red-500" : "border-gray-300"
                } shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm p-2 border`}
              />
              {errors.confirmPassword && (
                <p className="text-sm text-red-600">{errors.confirmPassword}</p>
              )}
            </div>

            {/* Botão Atualizar */}
            <div className="flex justify-end m-[1%]">
              <button
                type="submit"
                disabled={isSubmitting}
                className={`px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors ${
                  isSubmitting ? "opacity-70 cursor-not-allowed" : ""
                }`}
              >
                {isSubmitting ? "Atualizando..." : "Atualizar Senha"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SecuritySection;
